import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { http, messageError } from "./base";

export function getLinkToken() {
  return http.post("/billing/link-token/", {}).pipe(
    map(({ data }) => {
      return data;
    }),
    catchError(({ message }) =>
      throwError(message || "Unable to get link token.")
    )
  );
}

export function linkBankAccount(publicToken: string, accountId: string) {
  return http
    .post("/billing/bank-accounts/link/", { publicToken, accountId })
    .pipe(
      map(({ data }) => {
        return data;
      }),
      catchError(({ response: { data } }) => {
        return throwError(data.message || "Failed to link bank account.");
      })
    );
}

export function fetchBankAccounts() {
  return http.get("/billing/bank-accounts/").pipe(
    map(({ data }) => {
      return data;
    }),
    catchError(({ response: { data } }) => {
      return throwError(data.message || "Failed to fetch bank accounts.");
    })
  );
}

export function createCard(token: string) {
  return http.post("/billing/cards/", { token }).pipe(
    map(({ data }) => {
      return data;
    }),
    catchError(({ response: { data } }) => {
      return throwError(data.message || "Failed to create card.");
    })
  );
}

export function fetchCards() {
  return http.get("/billing/cards/").pipe(
    map(({ data }) => {
      return data;
    }),
    catchError(({ response: { data } }) => {
      return throwError(data.message || "Failed to fetch cards.");
    })
  );
}

export function createDeposit(accountId: string, sourceId: string, amount: number) {
  return http.post("/billing/deposits/", { accountId, sourceId, amount }).pipe(
    map(({ data }) => {
      return data;
    }),
    catchError(({ response: { data } }) => {
      return throwError(data.message || "Failed to create deposit.");
    })
  );
}

export function createRecurringDeposit(accountId: string, sourceId: string, amount: number, startDate: string) {
  return http.post("/billing/recurring-deposits/", { accountId, sourceId, amount, startDate }).pipe(
    map(({ data }) => {
      return data;
    }),
    catchError((error) => {
      return messageError(error, "Failed to create recurring deposit.");
    })
  );
}

